/**
 * Página del documento (`/documento/:id` sin lista de fondo): «Abrir como página» de la ventana, con la misma ficha de
 * dos mitades a ancho de página (decisión del dueño, 19-10; DESIGN.md §11.7). La ficha vive en
 * `components/documento/FichaDocumento.tsx`; los datos, en `hooks/useDocumento.ts`. Un enlace con «#p-k» abre el
 * texto en ese párrafo. El chat del documento salió de la ficha (01-11).
 */
import { Link, useLocation, useParams, useSearchParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Layout from '../components/layout/Layout';
import FichaDocumento from '../components/documento/FichaDocumento';
import { parrafoDeHash } from '../components/documento/VentanaDocumento';
import { useDocumento } from '../hooks/useDocumento';
import { collectionForDocument } from '../utils/institutions';
import { FOCO } from '../components/biblioteca/piezas';

export { LIMITE_TEXTO } from '../components/documento/TextoDocumento';

export default function DocumentDetail() {
  const { id = '' } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const datos = useDocumento(id);
  const { doc } = datos;

  // La cabecera lleva la biblioteca del documento y vuelve a ella; el documento se presenta en la ficha.
  const coleccion = doc ? collectionForDocument(doc.institution_code, doc.tipo) : undefined;
  const titulo = coleccion ? (
    <Link to={`/biblioteca/${coleccion.key}`} className={`inline-flex items-center gap-1.5 hover:text-indigo-700 rounded ${FOCO}`}>
      <ArrowLeft className="w-4 h-4 text-gray-400" aria-hidden="true" /> {coleccion.label}
    </Link>
  ) : 'Documento';

  return (
    <Layout title={titulo}>
      <div className="-m-4 lg:-m-8 h-[calc(100vh-85px)] bg-white">
        <div className="h-full max-w-[1220px]">
          <FichaDocumento key={id} id={id} datos={datos} modo="pagina" consulta={searchParams.get('q') || ''} parrafoInicial={parrafoDeHash(location.hash)} />
        </div>
      </div>
    </Layout>
  );
}
